import { Layout } from "react-grid-layout";

export const LOCAL_STORAGE_WIDGET_KEY = "dashboardWidgetTypes";
export const LOCAL_STORAGE_LAYOUT_KEY = "dashboardLayout";

export const loadWidgetsFromStorage = (): string[] => {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_WIDGET_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

export const saveWidgetsToStorage = (widgetTypes: string[]) => {
  localStorage.setItem(LOCAL_STORAGE_WIDGET_KEY, JSON.stringify(widgetTypes));
};

export const loadLayoutFromStorage = (): Layout[] => {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_LAYOUT_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

export const saveLayoutToStorage = (layout: Layout[]) => {
  localStorage.setItem(LOCAL_STORAGE_LAYOUT_KEY, JSON.stringify(layout));
};


